module.exports = __webpack_public_path__ + "img/hometop_sm.b3b09dd9.png";